export const SIGNUP = 'AUTH/SIGNUP';
export const SIGNUP_PENDING = `${SIGNUP}_PENDING`;
export const SIGNUP_FULFILLED = `${SIGNUP}_FULFILLED`;
export const SIGNUP_REJECTED = `${SIGNUP}_REJECTED`;

export const signup = (payload) => ({
  type: SIGNUP,
  payload,
});

export const RESET = `${SIGNUP}_RESET`;

export const reset = () => ({
  type: RESET,
});
